<template>
    <div
        class="cubeSpace d-flex flex-wrap justify-content-center align-items-center py-5 px-lg-0 px-4 px-lg-0 my- my-lg-0">

        <section
  class="fondo-flow"
  ref="rewardsSection"
  :class="{ 'is-visible': rewardsVisible }"
>
  <div class="flow-content">
    <h1 class="flow-title fuente-posm fuentes-flow">Rewards</h1>
    <div class="flow-row">
      <p class="flow-subtitle fuente-posm">
        Fideliza a tus mejores clientes e <br />incrementa ventas 30%
      </p>
      <router-link to="/reward" custom v-slot="{ navigate }">
        <button @click="navigate" class="flow-button fuente-nova2">
          DESCUBRE COMO
        </button>
      </router-link>
    </div>
  </div>
</section>

    </div>
</template><script>
export default {
    name: 'page2',
    emits: ['sendAction'],
    props: {
        action: {
            type: Object,
            default: () => { }
        }
    },
    watch: {
        action: {
            handler() {
                this.getAction()
            },
            deep: true
        }
    },
    data() {
        return {
            a9: require('@/assets/images/a9.webp'),
            rewardsVisible: false,
            observer: null
        }
    },
    mounted() {
        const section = this.$refs.rewardsSection
        if (!section) return

        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.rewardsVisible = true
                        // solo se anima una vez
                        if (this.observer) this.observer.disconnect()
                    }
                })
            },
            {
                threshold: 0.25 // cuando ~25% de la sección es visible
            }
        )

        this.observer.observe(section)
    },
    beforeUnmount() { // si el proyecto es Vue 2, cambia a beforeDestroy()
        if (this.observer) {
            this.observer.disconnect()
        }
    },
    methods: {
        makeAction() {
            switch (this.action.type) {
                case '?':
                    break
            }
        }
    },
}
</script>

<style lang="css" scoped>
.cubeSpace {
    overflow: hidden;
    height: auto;
    width: 100vw;
    height: 100vh;
    
}

.hover-boton_mod:hover {
    background-color: #040404;
    color: white;
    transition: all 0.4s linear;
}

.label-1 {
    color: var(--color-2);
    font-size: 70px;
    line-height: 1.1;
    max-width: 1000px;
    word-wrap: break-word;
    /* margin-top: -100px !important; */
}

.margen-negativo {
    padding-top: -40px !important;
    padding-top: -40px !important;

}

@media screen and (max-width: 1280px) {
    .button-outline {
        font-size: 18px;
        color: var(--color-2);
        text-align: center;
        outline: none;
        border-radius: 6px;
        padding: 5px 20px;
        background-color: transparent;
        border: 2px solid var(--color-2);
        cursor: pointer;
    }
}

@media (max-width: 992px) and (min-width: 768px) {
    .label-1 {
        font-size: 60px;
    }
}

@media (max-width: 767px) and (min-width: 0) {
    .label-1 {
        font-size: 34px;
    }
}
.fondo-flow {
    background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)), url('~@/assets/images/a80.webp');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    margin-top: 70px;
    height: 700px;
    width: 100%;
    color: white;
    border-top-left-radius: 65px;
    border-top-right-radius: 65px;

    /* ANIMACIÓN */
    transform: translateY(60px);
    opacity: 0;
    transition:
        transform 0.9s cubic-bezier(0.19, 1, 0.22, 1),
        opacity 0.9s ease-out;
}

.fondo-flow.is-visible {
    transform: translateY(0);
    opacity: 1;
}


/* ===== NUEVO CSS FLOW ===== */
.flow-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 0 60px;
    margin-top: 50px;
}

.flow-title {
    font-size: clamp(55px, 5vw, 88px) !important;
    font-weight: 700;
    margin: 0 0 20px 0;
    line-height: 1;
    color: white;
}

.flow-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 10px;
}

.flow-subtitle {
    font-size: clamp(20px, 5vw, 45px) !important;
    font-weight: 400;
    line-height: 1.2;
    margin-left: 40px;
    color: white;
}

.flow-button {
    background-color: transparent;
    color: white;
    border: 2px solid white;
    border-radius: 8px;
    padding: 14px 35px;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 1px;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
    margin-right: 30px;
}

.flow-button:hover {
    background-color: white;
    color: #040404;
}


/* ===== RESPONSIVE FLOW ===== */

@media (max-width: 1201px) {
    .fondo-flow {
    height: 500px;
    
}

}
@media (max-width: 992px) {
    .flow-content {
        padding: 0 40px;
    }

    .flow-title {
        font-size: 56px;
    }

    .flow-subtitle {
        font-size: 18px;
    }
}

@media (max-width: 767px) {
    .cubeSpace {
        padding-top: 20% !important;
    }
    .fondo-flow {
        height: 85%;
        border-radius: 15px !important;
        margin-bottom: 15px !important;
    }

    .flow-content {
        padding: 0 30px;
        align-items: center;
        text-align: center;
        
    }

    .flow-title {
        font-size: 42px;
    }

    .flow-row {
        flex-direction: column;
    }

    .flow-subtitle {
        font-size: 16px;
        margin-bottom: 25px;
    }

    .flow-subtitle br {
        display: none;
    }

    .fondo-flow {
        margin-top: 0px;
    }

    .flow-subtitle {

        margin-left: 0px;

    }

    .flow-button {

        margin-right: 0px;
    }

    .flow-content {
        margin-top: 0px;
    }
}
</style>